import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";  // Добавлен импорт для кнопки
import { useNavigate } from "react-router-dom";  // Импортируем useNavigate для редиректа
import homeLogo from "../../Assets/home-main.svg";
import newPhoto from "../../Assets/home-bg.jpg"; // Путь к новой фотографии
import Type from "./Type";


function Home() {
  const navigate = useNavigate();  // Создаём хук для навигации

  // Функция для обработки клика на кнопку
  const handleButtonClick = () => {
    console.log("Button clicked");
    navigate("/auth");  // Переход на страницу /auth
  };

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> SOUMYAJIT BEHERA</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                {/* Типографика (Typewriter Effect) */}
                <Type />
              </div>

              {/* Добавление кнопки с редиректом */}
              <div style={{ padding: 50, paddingTop: "20px" }}>
              <Button
                variant="primary"
                size="lg"
                style={{
                  padding: "10px 30px",
                  fontSize: "16px",
                  backgroundColor: "red",  // Проверка
                  zIndex: 9999,  // Убедитесь, что кнопка находится поверх других элементов
                  position: "relative"
                }}
                onClick={handleButtonClick}
              >
                Get Started
              </Button>
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>

      {/* Новая секция с фотографией и текстом */}
      <Container fluid className="new-section" id="new-section">
        <Row className="justify-content-center">
          <Col md={6} className="text-center">
            <img
              src={newPhoto}
              alt="New Section Image"
              className="img-fluid"
              style={{ maxWidth: "100%", borderRadius: "8px" }}
            />
            <h3 className="new-section-heading" style={{ paddingTop: "20px" }}>
              Why Choose Us?
            </h3>
            <p className="new-section-text" style={{ color: "white" }}>
              We provide excellent services to help you achieve your goals.
            </p>
          </Col>
        </Row>

        {/* Преимущества в колонках */}
        <Row className="benefits-row" style={{ paddingTop: "50px" }}>
          <Col md={4} className="benefit-col">
            <h4 className="benefit-heading">Benefit 1</h4>
            <p className="benefit-description">
              We offer personalized support to ensure success.
            </p>
          </Col>
          <Col md={4} className="benefit-col">
            <h4 className="benefit-heading">Benefit 2</h4>
            <p className="benefit-description">
              Our team is dedicated to providing the best experience.
            </p>
          </Col>
          <Col md={4} className="benefit-col">
            <h4 className="benefit-heading">Benefit 3</h4>
            <p className="benefit-description">
              We use the latest technologies for improved outcomes.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
